<template>
  <div>
    <v-dialog
      style="z-index: 9999"
      v-model="isOpen"
      persistent
      max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">Actualización de datos personales</span>
        </v-card-title>
        <v-divider />
        <br>
        <v-card-text class="text-justify">
          <span>
            Hemos detectado que en tu perfil falta información importante. Es probable que aún no hayas ingresado algunos datos necesarios, incluyendo:
            <ul>
              <br>
              <li>Nombres</li>
              <li>Apellidos</li>
              <li>Teléfono</li>
            </ul>
            <br>
            Necesitamos que nos brindes la siguiente información para nosotros dar un mejor servicio sobre la refencia de quién es el que usa la plataforma.
          </span>
          <v-form ref="form" v-model="form.isValid">
            <v-flex xs12 md12>
              <v-text-field
                label="Nombres"
                v-model="form.data.firstName"
                :rules="form.rules.firstName"
                required
              />
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Apellidos"
                v-model="form.data.lastName"
                :rules="form.rules.lastName"
                required
              />
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                label="Teléfono"
                v-model="form.data.phone"
                :rules="form.rules.phone"
                maxlength="10"
                required
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submit" :disabled="!form.isValid">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        isValid: false,
        data: {
          firstName: null,
          lastName: null,
          phone: null
        },
        rules: {
          firstName: [
            v => !!v || this.$t('validations.firstName'),
            v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
          ],
          lastName: [
            v => !!v || this.$t('validations.lastName'),
            v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
          ],
          phone: [
            v => !!v || 'Phone is required',
            v => /[0-9]/.test(v) || 'Enter a valid number',
            v => v.length === 10 || 'Phone must be a 10 digits long'
          ]
        }
      }
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.form.data = {
          firstName: this.data.firstName || '',
          lastName: this.data.lastName || '',
          phone: this.data.phone || ''
        }
      }
    }
  },
  computed: {
    userId () {
      return this.$store.state.login.user._id
    }
  },
  methods: {
    open () {
      if (!this.userId) {
        this.closeDialog()
      } else {
        this.isOpen = true
      }
    },
    closeDialog () {
      this.isOpen = false
    },
    async submit () {
      this.overlay = true
      try {
        const response = await this.$api.put(`/v1/users/${this.userId}`, this.form.data)
        const payload = response
        payload.uuid = this.userId
        this.$store.commit('login/user/set', payload)

        this.$toasted.show('Se ha actualizado correctamente la información de usuario.', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>
